import React from 'react';
import Icon from './Icons';
import {Checkbox} from './FormElements';
import * as myfunction from '../functions';

export default function ListSortedItemsCheckboxes({list,items,inlineItems,onCheck,multiple,hasParent,conditions,conditionOperator,unSelectParent}) {
    const [droppedItems, setDroppedItems] = React.useState([]);

    const itemsHtml = [];

    if( items && Array.isArray(items) ){
        items.map(item => {
            const itemId = item.id;
            let displayItem = true;
            
            if( conditions && conditions.length > 0 ){
                let show = [];

                for (const condition of conditions) {
                    if( (condition.relation === '===' && item[condition.key] === condition.value) || (condition.relation === '!==' && item[condition.key] !== condition.value) )
                        show.push(true);
                    else
                        show.push(false);
                }

                show = Array.from(new Set(show));
    
                if( show.length > 1 && conditionOperator === 'and' )
                    displayItem = false;
                else
                    displayItem = show[0]
            }
            
            if( displayItem )
                itemsHtml.push(
                    <div key={itemId} className="category-item">
                        <div className={`item ${(multiple && myfunction.inArray(itemId,list) || itemId === list) && 'selected'} ${!item.children && "pleft" || ""}`}>
                            {
                                item.children && 
                                <Icon
                                    icon={myfunction.inArray(itemId,droppedItems) && "minus" || "plus"}
                                    onClick={() => {
                                        const list = droppedItems;
                                        
                                        if(myfunction.inArray(itemId,droppedItems)){
                                            const key = list.findIndex((e) => e === itemId);
                                            list.splice(key,1);
                                        } else
                                            list.push(itemId);

                                        setDroppedItems([...list]);
                                    }}
                                />
                            }
                            <Checkbox 
                                label={item.name} 
                                size="small"
                                onChange={(checked) => {
                                    let newList = list;

                                    if( multiple ){
                                        if( checked && !myfunction.inArray(itemId,newList))
                                            newList.push(itemId)
        
                                        if( !checked && myfunction.inArray(itemId,newList)){
                                            const key = newList.findIndex((e) => e === itemId);
                                            newList.splice(key,1);
                                        }

                                        let finalList = []
    
                                        for (const itemId of newList) {
                                            if( inlineItems && inlineItems[itemId] )
                                                finalList.push(itemId);
                                        }
    
                                        onCheck(finalList);
                                    }else{
                                        if( newList !== itemId)
                                            newList = [itemId]
                                        else
                                            newList = []

                                        onCheck(newList);
                                    }
                                }}
                                checked={multiple && myfunction.inArray(itemId,list) || itemId === list}
                                disabled={ (item.children && unSelectParent) }
                            />
                        </div>
                        {
                            item.children && myfunction.inArray(itemId,droppedItems) && 
                            <ListSortedItemsCheckboxes 
                                list={list}
                                items={item.children}
                                inlineItems={inlineItems}
                                onCheck={onCheck}
                                multiple={multiple}
                                conditions={conditions}
                                conditionOperator={conditionOperator}
                                unSelectParent={unSelectParent}
                                hasParent={true}
                            />
                        }
                    </div>
                )
        })
    }

    return <div className={`category-items ${!hasParent?'scroller':''}`}>{itemsHtml}</div>;
}